// Matches for one lower case letter, one uppercase letter, one special symbol, one number, minimum length of 12
const passwordRegex = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{12,})/;

export { passwordRegex };
